export const EMAIL_CHANGE_QUEUED_KEY = 'basic_details.natural_person_form.email_change_queued';

/**
 * Structural slice of the CAP_MANAGE translate function. Narrower than `TranslateFunction`, so the
 * real one is assignable to it and a spec can supply a plain `jest.fn()` without a cast.
 */
export type EmailChangeQueuedTranslate = (
	key: typeof EMAIL_CHANGE_QUEUED_KEY,
	args: { newEmail: string }
) => string;

/** Queued, not applied: the address goes to the identity provider and our rows follow the event. */
export const buildEmailChangeQueuedToast = (
	tCapManage: EmailChangeQueuedTranslate,
	newEmail: string
): { title: string; state: 'success' } => ({
	title: tCapManage(EMAIL_CHANGE_QUEUED_KEY, { newEmail }),
	state: 'success',
});
